import { useCallback } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const TriceptalInput: React.FC = () => {
  const data = evaluationAtom.get()

  const handleUpdateField = useCallback(
    (index: number, value: number) => {
      const newArr = data ? data.triceptal : []
      newArr[index] = +value
      patchEvaluationAtom({ triceptal: newArr })
    },
    [data],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(5)
  }, [])

  return (
    <>
      <div className='whitespace-nowrap font-bold xl:font-normal'>
        Triceptal (mm) &nbsp;
      </div>
      {data?.triceptal.map((val, index) => (
        <div key={`triceptal-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            value={val}
            mask='float'
            placeholder='0'
            onFocus={handleFocus}
            inputMode='numeric'
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='triceptal' />
      </div>
    </>
  )
}
